<style lang="scss" scoped>
.item {
  padding-top: 10px;
  .info {
    background-color: #fff;
    padding: 15px;
    border-color: #d7dde4;
    border-collapse: separate;
    border-style: solid;
    border-width: 1px 1px 0 1px;

    .right {
      float: right;
    }

    .i {
      width: 100px;
      display: inline-block;
    }
  }
}

.menu-box {
  padding-right: 5px;
}
</style>

<template>
  <div>
    <div class="tools">
      <span class="menu-box"> 订单状态 </span>
      <span class="menu-box">
        <Select v-model="state" clearable style="width: 100px">
          <Option value="0">待审批</Option>
          <Option value="1">已审批</Option>
          <Option value="2">已撤销</Option>
        </Select>
      </span>
      <span class="menu-box">
        <i-input
          v-model="query"
          placeholder="请输入..."
          style="width: 200px"
        ></i-input>
      </span>
      <span class="menu-box">
        <i-button @click="load">查询</i-button>
      </span>
      <span class="menu-box">
        <i-button @click="$refs.delivery.show()">新建</i-button>
      </span>
    </div>
    <div class="item" v-for="row in source" :key="row.no">
      <div class="info">
        <span class="i">{{ row.no }}</span>
        <span class="i">{{ row.customerName }}</span>
        <span class="i">{{ row.customerPhone }}</span>
        <span class="i">{{ row.note }}</span>
        <span class="right">
          {{ row.saleName }} {{ row.state }} {{ row.createdAt }}
          <i-button
            v-if="row.state == '待审核'"
            @click="edit(row)"
            style="margin-right: 5px"
          >
            修改
          </i-button>
          <i-button @click="print(row)">打印</i-button>
        </span>
      </div>
      <i-table highlight-row :columns="columns" :data="row.items"></i-table>
    </div>
    <page
      :total.sync="page.total"
      @on-change="pageChange"
      :style="{ 'margin-top': '10px', 'margin-left': '100px' }"
      :current.sync="page.current"
    ></page>
    <delivery ref="delivery" @finish="load"></delivery>
    <EditDelivery ref="edit" @finish="load"></EditDelivery>
  </div>
</template>

<script>
import Delivery from './delivery';
import EditDelivery from './edit-delivery';
import axios from 'axios';

export default {
  components: {
    Delivery,
    EditDelivery,
  },
  data() {
    return {
      state: '',
      query: '',
      page: {
        total: 0,
        current: 1,
        pagesize: 10,
      },
      columns: [
        {
          title: '编码',
          key: 'categoryId',
        },
        {
          title: '名称',
          key: 'name',
        },
        {
          title: '数量',
          key: 'count',
        },
        {
          title: '价格',
          key: 'price',
        },
        {
          title: '合计',
          key: 'total',
        },
      ],
      source: [],
      currentRow: {},
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    edit(row) {
      this.$refs.edit.show(row);
    },
    print(row) {
      let no = row.no;
      this.$http.post('delivery/print', { no }).then(({ data }) => {
        return axios.post('http://127.0.0.1:8080', data);
      });
    },
    load() {
      let { current, pagesize } = this.page;

      this.$http
        .post('delivery/find', {
          state: this.state,
          name: this.query,
          offset: (current - 1) * pagesize,
          limit: pagesize,
        })
        .then(({ data }) => {
          if (data.msg === 'ok') {
            this.source = data.rows;
            this.page.total = data.count;
          }
        });
    },
    pageChange() {
      this.load();
    },
  },
};
</script>
